import { formatting } from '../../../qaamgo/helper/formatting';
import File from '../core/add-helper/file';
import { INPUT_EVENT_UPLOAD_PROGRESS } from '../core/event';

class UploadProgressmanager {
    constructor() {
        this.files = [];
    }
    getUploadFilesProgress(event, localId, data) {
        if (localId > this.files.length) {
            return;
        }
        if (localId === this.files.length) {
            const file = new File(localId);

            this.files.push(file);
        }
        if (localId && localId >= 0) {
            const input = global.qgUploader.getInput(localId);

            this.files[localId].setDataFromInput(input);
            this.files[localId].lastEventData = data;
        }
        if (event === INPUT_EVENT_UPLOAD_PROGRESS) {
            const progressData = this.handleUploadProgress(this.files[localId], data);

            this.files[localId].progressPercent = progressData.progressPercent;

            this.files[localId].progressText = progressData.progressText;

            this.files[localId].bytesLoaded = progressData.bytesLoaded;

            this.files[localId].bytesTotal = progressData.bytesTotal;
        }
        return this.files;
    }
    handleUploadProgress(file, data) {
        // DEAL WITH PERCENTAGE
        const rawPercentage = (data.bytesLoaded / data.bytesTotal) * 100;
        const progressPercentage = Math.floor(rawPercentage);

        // DEAL WITH BITRATE
        file.updateAverageBitrate(data.bitrate);

        // DEAL WITH TIME LEFT DATA
        const bytesRemaining = data.bytesTotal - data.bytesLoaded;
        const secondsRemaining = (bytesRemaining * 8) / file.progressAverageBitrate + 1;
        const timeLeft = formatting.time(secondsRemaining);

        return {
            progressPercent: progressPercentage,
            progressText: timeLeft,
            bytesLoaded: data.bytesLoaded,
            bytesTotal: data.bytesTotal
        };
    }
}

export default new UploadProgressmanager();
